import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEscapeKeydown as e } from "@radix-ui/react-use-escape-keydown";
import { useCallbackRef as t } from "@radix-ui/react-use-callback-ref";
import { useBodyPointerEvents as n } from "@radix-ui/react-use-body-pointer-events";
import { useComposedRefs as r } from "@radix-ui/react-compose-refs";
import { Primitive as s } from "@radix-ui/react-primitive";
import { composeEventHandlers as o } from "@radix-ui/primitive";
import * as i from "react";
import a from "@babel/runtime/helpers/esm/extends";
var u = /*#__PURE__*/i.createContext({
  layers: new Set(),
  layersWithOutsidePointerEventsDisabled: new Set(),
  branches: new Set()
});
export var DismissableLayer = /*#__PURE__*/i.forwardRef(function (l, m) {
  var _l$disableOutsidePoin = l.disableOutsidePointerEvents,
      f = _l$disableOutsidePoin === void 0 ? !1 : _l$disableOutsidePoin,
      p = l.onEscapeKeyDown,
      v = l.onPointerDownOutside,
      b = l.onFocusOutside,
      E = l.onInteractOutside,
      y = l.onDismiss,
      w = _objectWithoutProperties(l, ["disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss"]),
      h = i.useContext(u),
      _i$useState = i.useState(null),
      _i$useState2 = _slicedToArray(_i$useState, 2),
      D = _i$useState2[0],
      x = _i$useState2[1],
      _i$useState3 = i.useState({}),
      _i$useState4 = _slicedToArray(_i$useState3, 2),
      C = _i$useState4[1],
      L = r(m, function (e) {
    return x(e);
  }),
      P = Array.from(h.layers),
      _slice = _toConsumableArray(h.layersWithOutsidePointerEventsDisabled).slice(-1),
      _slice2 = _slicedToArray(_slice, 1),
      O = _slice2[0],
      g = P.indexOf(O),
      B = D ? P.indexOf(D) : -1,
      R = h.layersWithOutsidePointerEventsDisabled.size > 0,
      F = B >= g,
      S = function (e) {
    var n = t(e),
        r = i.useRef(!1);
    return i.useEffect(function () {
      var e = function e(_e) {
        if (_e.target && !r.current) {
          d("dismissableLayer.pointerDownOutside", n, {
            originalEvent: _e
          });
        }

        r.current = !1;
      },
          t = window.setTimeout(function () {
        document.addEventListener("pointerdown", e);
      }, 0);

      return function () {
        window.clearTimeout(t), document.removeEventListener("pointerdown", e);
      };
    }, [n]), {
      onPointerDownCapture: function onPointerDownCapture() {
        return r.current = !0;
      }
    };
  }(function (e) {
    var t = e.target,
        n = _toConsumableArray(h.branches).some(function (e) {
      return e.contains(t);
    });

    F && !n && (null == v || v(e), null == E || E(e), e.defaultPrevented || null == y || y());
  }),
      W = function (e) {
    var n = t(e),
        r = i.useRef(!1);
    return i.useEffect(function () {
      var e = function e(_e2) {
        if (_e2.target && !r.current) {
          d("dismissableLayer.focusOutside", n, {
            originalEvent: _e2
          });
        }
      };

      return document.addEventListener("focusin", e), function () {
        return document.removeEventListener("focusin", e);
      };
    }, [n]), {
      onFocusCapture: function onFocusCapture() {
        return r.current = !0;
      },
      onBlurCapture: function onBlurCapture() {
        return r.current = !1;
      }
    };
  }(function (e) {
    var t = e.target;
    _toConsumableArray(h.branches).some(function (e) {
      return e.contains(t);
    }) || (null == b || b(e), null == E || E(e), e.defaultPrevented || null == y || y());
  });

  return e(function (e) {
    B === h.layers.size - 1 && (null == p || p(e), e.defaultPrevented || null == y || y());
  }), n({
    disabled: f
  }), i.useEffect(function () {
    D && (f && h.layersWithOutsidePointerEventsDisabled.add(D), h.layers.add(D), c());
  }, [D, f, h]), i.useEffect(function () {
    return function () {
      D && (h.layers.delete(D), h.layersWithOutsidePointerEventsDisabled.delete(D), c());
    };
  }, [D, h]), i.useEffect(function () {
    var e = function e() {
      return C({});
    };

    return document.addEventListener("dismissableLayer.update", e), function () {
      return document.removeEventListener("dismissableLayer.update", e);
    };
  }, []), /*#__PURE__*/i.createElement(s.div, a({}, w, {
    ref: L,
    style: _objectSpread({
      pointerEvents: R ? F ? "auto" : "none" : void 0
    }, l.style),
    onFocusCapture: o(l.onFocusCapture, W.onFocusCapture),
    onBlurCapture: o(l.onBlurCapture, W.onBlurCapture),
    onPointerDownCapture: o(l.onPointerDownCapture, S.onPointerDownCapture)
  }));
});
/*#__PURE__*/

export var DismissableLayerBranch = /*#__PURE__*/i.forwardRef(function (e, t) {
  var n = i.useContext(u),
      o = i.useRef(null),
      c = r(t, o);
  return i.useEffect(function () {
    var e = o.current;
    if (e) return n.branches.add(e), function () {
      n.branches.delete(e);
    };
  }, [n.branches]), /*#__PURE__*/i.createElement(s.div, a({}, e, {
    ref: c
  }));
});
/*#__PURE__*/

function c() {
  var e = new Event("dismissableLayer.update");
  document.dispatchEvent(e);
}

function d(e, t, n) {
  var r = n.originalEvent.target,
      s = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  return t && r.addEventListener(e, t, {
    once: !0
  }), !r.dispatchEvent(s);
}

export var Root = DismissableLayer;
export var Branch = DismissableLayerBranch;